import { DashletSettingsForm, DashletSettingsGroup, DashletSettingDropdown, DashletSettingList } from '@models/index';

import { AccountService, DashletSettingsService } from '@services/index';

export class DashletSettingsFormAlarmOverview extends DashletSettingsForm {
    private customer!: DashletSettingDropdown;
    private severityGroups: DashletSettingList<any>;

    private isCust!: boolean;

    private customerId!: string;

    constructor(
        private readonly settingsService: DashletSettingsService,

        private readonly accountService: AccountService
    ) {
        super();

        this.init();
        this.loadSeverity();

        this.loadCustomers();
    }

    loadState(obj: { [key: string]: object }): void {
        super.loadState(obj);
    }

    private init(): void {
        const group = new DashletSettingsGroup();

        const s: any = (group.settings = []);

        const user = this.accountService.getUserDetails();

        this.isCust = user.EntityGroup === 2;

        this.customerId = user.EntityId;

        const customer = (this.customer = new DashletSettingDropdown());

        customer.label = 'Customer';

        customer.stateKey = 'customer';

        customer.disabled = true;

        customer.change.subscribe(() => {
            this.clearAndDisable(this.severityGroups);
            this.loadSeverity();
        });

        s.push(customer);

        const severity = (this.severityGroups = new DashletSettingList<string>());
        severity.label = 'Severity';
        severity.stateKey = 'severitySettings';
        severity.disabled = true;
        severity.multiple = true;
        severity.metaKeySelection = false;
        s.push(severity);

        this.updateSettings(group);
    }

    private loadCustomers(): void {
        this.enableAndLoading(this.customer);

        this.settingsService.getUserAssociatedCustomers().subscribe(
            (customers: any) => {
                this.customer.items = customers;

                this.customer.loadingComplete();
            },

            () => {
                this.customer.loadingComplete();

                this.customer.disabled = true;

                // show error notification here
            }
        );
    }

    private enableAndLoading(widget: DashletSettingDropdown | DashletSettingList<string>) {
        widget.disabled = false;

        widget.loadingBegin();
    }

    private loadSeverity(): void {
        this.enableAndLoading(this.severityGroups);
        const group = [];
        for (let i = 0; i < 3; i++) {
            group.push({ label: `${i} - High`, value: i });
        }

        for (let i = 3; i < 6; i++) {
            group.push({ label: `${i} - Medium`, value: i });
        }

        for (let i = 6; i < 11; i++) {
            group.push({ label: `${i} - Low`, value: i });
        }

        this.severityGroups.items = group;
        this.severityGroups.loadingComplete();
    }

    private clearAndDisable(widget: DashletSettingDropdown | DashletSettingList<string>) {
        widget.disabled = true;
        widget.items = [];
        if (widget instanceof DashletSettingList) {
            widget.values = [];
        } else {
            widget.value = null;
        }
    }
}
